import React from 'react';
import PropTypes from 'prop-types';

import './styles.css';

const BasicTextArea = React.forwardRef(
  (
    {
      resize,
      name,
      rows,
      maxlength,
      disabled,
      autoFocus,
      content,
      placeholder,
      isValid,
      touchFunc,
      onKeyUp,
      controlFunc,
      onKeyPressHandler,
    },
    ref
  ) => {
    const handleChange = event => {
      controlFunc(event);
    };

    const handleKeyUp = event => {
      if (onKeyUp) {
        onKeyUp(name, event);
      }
      event.persist();
    };

    const inputClassNames = isValid
      ? 'basic-textarea'
      : 'basic-textarea basic-textarea--invalid';

    return (
      <div className="basic-textarea__wrapper">
        <textarea
          className={inputClassNames}
          disabled={disabled ? true : null}
          style={resize ? null : { resize: 'none' }}
          name={name}
          rows={rows}
          value={content}
          onKeyPress={onKeyPressHandler}
          onChange={handleChange}
          onKeyUp={handleKeyUp}
          onBlur={touchFunc}
          placeholder={placeholder}
          autoFocus={autoFocus}
          ref={ref}
          maxLength={maxlength}
        />
      </div>
    );
  }
);

BasicTextArea.defaultProps = {
  autoFocus: false,
};

BasicTextArea.propTypes = {
  rows: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  autoFocus: PropTypes.bool,
  content: PropTypes.string.isRequired,
  resize: PropTypes.bool,
  placeholder: PropTypes.string,
  controlFunc: PropTypes.func.isRequired,
  isValid: PropTypes.bool.isRequired,
  touchFunc: PropTypes.func,
  onKeyPressHandler: PropTypes.func,
};

export default BasicTextArea;
